module.exports = __webpack_public_path__ + "img/正面.4cb9a5cc.png";